import gql from 'graphql-tag'
import { BrandFragment } from '@/graphql/fragments/vehicle'

export const mutation = gql`
  ${BrandFragment}
  mutation updateBrand($id: Int!, $fields: vehicle_brand_set_input!) {
    record: update_vehicle_brand_by_pk(pk_columns: {id: $id}, _set: $fields) {
      ...Brand
    }
  }
`

export default mutation
